
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Rund zwei Tage weniger Migräne pro Monat brachte in einer Studie ein kleines Elektrostimulationsgerät namens «Cefaly» zum Anbringen auf der Stirn oder am Hinterkopf. Es kann auch beim akuten Anfall schmerzlindernd wirken.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;